import HoverPrefetchLink from '@/components/hover-prefetch-link';
import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import clsx from 'clsx';
import { useRef, useState } from 'react';

interface Props {
  mode?: 'link';
  href?: string;
  isActive: boolean;
  onClick?: () => void;
  className?: string;
}

const StockFilterItem = (props: Props) => {
  const { mode, href = '#', isActive, onClick, className } = props;

  const [checked, setChecked] = useState(isActive);

  const prevPropsRef = useRef({
    isActive,
  });

  if (prevPropsRef.current.isActive !== isActive) {
    prevPropsRef.current.isActive = isActive;
    setChecked(isActive);
  }

  if (mode === 'link') {
    return (
      <HoverPrefetchLink
        href={href}
        onClick={() => {
          setChecked(x => !x);
          onClick?.();
        }}
        data-filter-link='1'
        className={cn('flex max-w-max items-start gap-x-2 py-[15px]', className)}
      >
        <div
          className={clsx(
            ' relative h-6 w-11 px-0.5',
            'rounded-full',
            checked ? ' bg-theme' : ' bg-[#cccccc]',
            'ease-[cubic-bezier(0.4, 0, 0.2, 1)] transition-[background-color] duration-2xl',
          )}
        >
          <div
            className={clsx(
              ' h-5 w-5 rounded-[50%] ',
              'bg-white',
              checked ? 'left-[calc(100%_-_22px)] ' : 'left-0.5',
              'absolute top-1/2 -translate-y-1/2',
              'ease-[cubic-bezier(0.4, 0, 0.2, 1)] transition-[left] duration-2xl',
            )}
          />
        </div>

        <div className='flex flex-col gap-1'>
          <div className='leading-none text-80583F'>Quick Delivery</div>
          <div className='text-[15px] leading-none '>In stock items</div>
        </div>
      </HoverPrefetchLink>
    );
  }

  return (
    <div className={cn('flex items-start space-x-2 py-[15px]', className)}>
      <Switch
        checked={checked}
        onCheckedChange={value => {
          setChecked(value);
          onClick?.();
        }}
      />
      <div
        className='flex flex-col gap-1'
        onClick={() => {
          setChecked(x => !x);
          onClick?.();
        }}
      >
        <div className='leading-none text-80583F'> Quick Delivery</div>
        <div className='text-sm leading-none'>In stock items</div>
      </div>
    </div>
  );
};

export default StockFilterItem;
